module.exports = __webpack_public_path__ + "static/img/org_title8.1176585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title8.png
// module id = /7Lq
// module chunks = 4